import React from 'react';
import {Route} from 'react-router-dom';
import AsyncPage from './async';
import DefaultBusinessLayout from '../../../components/layout/DefaultBusinessLayout';

export default [
  <Route key="/business/compliance" element={<DefaultBusinessLayout />}>
    <Route path="business/compliance" element={<AsyncPage />} />
  </Route>,
];
